export const getReturnManifestBadgeColor = status => {
  switch (status) {
    case 'created':
      return 'secondary';

    case 'pending':
      return 'warning';

    case 'closed':
    case 'discarded':
      return 'danger';

    default:
      return 'secondary';
  }
};
